import React from 'react'

import { actionsColumn, conditionNameColumn, providersColumn, sitesColumn } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { priceChangeComparisonColumn } from "Pages/ReportsAlerts/Alerts/Conditions/PriceChange/Table/columns"
import CreateAlertsButton from "Pages/ReportsAlerts/Alerts/Conditions/CreateAlerts"
import { dsColorNew } from "@palette"


export default function PriceChangeTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		createButton={<CreateAlertsButton/>}
		title="Alerts: Price Change"
		data={data}
		isLoading={isLoading}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			...sitesColumn(),
			providersColumn(),
			priceChangeComparisonColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)
		]}
		legend={[
			{ icon: "percent", value: "%", label: "Percentage" },
			{ icon: "money-bills", value: "$", label: "Currency", iconProps: { color: dsColorNew.successText } },
			{
				icon: "arrow-up",
				value: "Price increase",
				label: "Price increase",
				iconProps: { color: dsColorNew.successText }
			},
			{
				icon: "arrow-down",
				value: "Price decrease",
				label: "Price Decrease",
				iconProps: { color: dsColorNew.dangerRed }
			},
			{
				icon: "arrow-down-arrow-up",
				value: "Price increase/decrease",
				label: "Price Difference",
				iconProps: { color: dsColorNew.noteAmber }
			},
		]}
	/>
}